// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.state {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-content: center;
  gap: 2vw;
  flex-wrap: wrap;
}
.state .dataCard {
  background-color: #fff;
  border-radius: 0.5em;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  padding: 1em;
}
.state .revenueCard {
  width: 92%;
  height: 20rem;
}
.state .customerCard {
  width: 50%;
  height: 20rem;
}
.state .categoryCard {
  width: 40%;
  height: 20rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Statistique/state.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;AACF;AACE;EACE,sBAAA;EACA,oBAAA;EACA,iDAAA;EACA,YAAA;AACJ;AAEE;EACE,UAAA;EACA,aAAA;AAAJ;AAGE;EACE,UAAA;EACA,aAAA;AADJ;AAIE;EACE,UAAA;EACA,aAAA;AAFJ","sourcesContent":[".state {\n  height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  gap: 2vw;\n  flex-wrap: wrap;\n\n  .dataCard {\n    background-color: #fff;\n    border-radius: 0.5em;\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n    padding: 1em;\n  }\n  \n  .revenueCard {\n    width: 92%;\n    height: 20rem;\n  }\n  \n  .customerCard {\n    width: 50%;\n    height: 20rem;\n  }\n  \n  .categoryCard {\n    width: 40%;\n    height: 20rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
